export default __webpack_public_path__ + "book_details-word_wise.83ff7652.png";